import { useRef, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  Accordion,
  Button,
  Checkbox,
  ICheckboxOptions,
  IData,
} from '../../../component';
import AverageIncomeSwitch from './components/averageIncome/averageIncomeSwitch';

import {
  clearDataLayers,
  handleCheckbox,
} from './controllers/dataLayers.controller';

import { ILayerProps } from '../types';
import { RootState } from '../../../reducer';

import './dataLayers.scss';
import AverageIncomeOptions from './components/averageIncome/averageIncomeOptions';
import FlowPointsOptions from './components/flowPoints/flowPointsOptions';
import FlowPointsSwitch from './components/flowPoints/flowPointsSwitch';

interface IDataLayersProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const DataLayers = ({ isOpen }: IDataLayersProps): JSX.Element => {
  const dispatch = useDispatch();

  const [data, setData] = useState<ILayerProps[]>([]);

  const { preference, profileRules } = useSelector(
    (state: RootState) => state.layoutState
  );

  const nls = require(`./nls/${preference.language.id}.json`);
  const { dataLayers } = useSelector(
    (state: RootState) => state.dataLayersState
  );
  const containerRef = useRef(null);

  const validateRules = () => {
    const { dataLayerAccessRules, hasAccessGeneralMarkets } = profileRules;
    const { hasAccessDistricts, hasAccessZoning, hasAccessValueZoning } =
      dataLayerAccessRules;

    const newData: ILayerProps[] = [];

    if (hasAccessDistricts) {
      newData.push({
        name: 'Distritos',
        id: 'neighborhood',
      });
    }
    if (hasAccessZoning) {
      // newData.push({
      //   name: 'Zoneamento',
      //   id: 'zoning',
      // });
    }
    if (hasAccessValueZoning && !hasAccessGeneralMarkets) {
      newData.push({
        name: 'Zonas de valor',
        id: 'valueZoning',
      });
    }
    newData.push({
      title: 'Renda familiar média',
      name: 'Renda familiar média',
      id: 'averageIncome',
      content: <AverageIncomeOptions />,
      defaultDisabled: dataLayers.averageIncome.selected,
      leftHeaderContent: <AverageIncomeSwitch />,
    });

    // TODO: Waiting for flow points task refining
    newData.push({
      title: 'Pontos de fluxo',
      name: 'Pontos de fluxo',
      id: 'flowPoints',
      content: <FlowPointsOptions />,
      leftHeaderContent: <FlowPointsSwitch />,
    });

    // TODO: Waiting for socioeconomic data layers implementation
    //
    // newData.push({
    //   name: 'Setores censitários',
    //   id: 'censusSectors',
    // });
    //   name: 'Densidade demográfica',
    //   id: 'demographicDensity',
    // });
    // newData.push({
    //   name: 'Verticalização',
    //   id: 'verticalization',
    // });

    return newData;
  };

  useEffect(() => {
    if (profileRules) {
      setData(validateRules());
    }
  }, [profileRules]);

  return (
    <div className="data-layers-actions--full-container" ref={containerRef}>
      {isOpen && (
        <div className="data-layers--full-container">
          <p data-cy="DataLayersTitle" className="data-layer--title">
            {nls.layers}
          </p>
          {data.map((layer) => {
            return (
              <section
                className="layer-checkbox-container"
                data-cy={`DataLayer${layer.id}-Container`}
                key={layer.id}
              >
                {layer.content ? (
                  <Accordion
                    cy={`DataLayerAccordion${layer.id}`}
                    data={[layer as IData]}
                    tabSelect={'0'}
                    actionTab={() => {}}
                    type="custom"
                    leftHeaderContent={layer.leftHeaderContent}
                    openAccordion={
                      dataLayers[layer.id].selected ? layer.id : ''
                    }
                  />
                ) : (
                  <Checkbox
                    cy={`DataLayer${layer.id}`}
                    action={(event) =>
                      handleCheckbox(
                        event as ICheckboxOptions,
                        layer.name,
                        layer.id
                      )
                    }
                    name={layer.id}
                    checked={dataLayers[layer.id].selected}
                    label={layer.name}
                    type="switch"
                  />
                )}
              </section>
            );
          })}
          <Button
            className="data-layers-clear-button btn"
            onClick={() => {
              dispatch([clearDataLayers()]);
            }}
            cy="DataLayersClearBtn"
          >
            {nls.clearDataLayers}
          </Button>
        </div>
      )}
    </div>
  );
};

export default DataLayers;
